/** Shared page-size choices, used by both the SettingsPanel control and the
 * pagination footer's page-size selector so the two can never diverge.
 *
 * Union of the legacy datagrid options (15/25/50/75) and the eag-grid ones —
 * presets are persisted per user on the BE and shared between both grids, so
 * dropping a legacy value (e.g. the old default 15) would leave the selectors
 * with no matching option and render them unselected (T20-133879). */
export const PAGE_SIZE_OPTIONS = [15, 25, 50, 75, 100, 200];
